module.exports = __webpack_public_path__ + "static/img/h2-5.cbb8acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-5.png
// module id = jFJ1
// module chunks = 1